import PropTypes from 'prop-types'

export const ShapeDataType = PropTypes.shape({
    id: PropTypes.number.isRequired, // Double,
    name: PropTypes.string, // Option[String],
    project: PropTypes.string, // Option[String],
    version: PropTypes.number, // Option[Double],
    showData: PropTypes.bool, // Option[Boolean],
    showSum: PropTypes.bool, // Option[Boolean],
    warningLimit: PropTypes.number, // Option[Long],
    alertLimit: PropTypes.number, // Option[Long],
    unit: PropTypes.string, // Option[String],
    order: PropTypes.number, // Option[Int],
    calculMin: PropTypes.bool, // Option[Boolean],
    calculMoy: PropTypes.bool, // Option[Boolean],
    calculMax: PropTypes.bool, // Option[Boolean],
    codeParameter: PropTypes.string, // Option[String],
    monitoringChronicle: PropTypes.bool, // Option[Boolean],
    codeUnit: PropTypes.string, // Option[String]
    color: PropTypes.string, // Option[String]
    isIncrement: PropTypes.bool, // Option[Boolean]
    razThreshold: PropTypes.number, // Option[Double]
    lineType: PropTypes.string, // Option[String]
    lineWidth: PropTypes.number, // Option[Int]
    lineOpacity: PropTypes.number, // Option[Double]
    comment: PropTypes.string, // Option[String]
    numberDecimal: PropTypes.number, // Option[Int]
})

export const HeaderDataType = ['name', 'id', 'version', 'showData', 'warningLimit', 'alertLimit', 'unit', 'order', 'calculMin', 'calculMoy', 'calculMax', 'codeParameter', 'monitoringChronicle', 'codeUnit']